import Select from 'react-select'
import { Button } from '../../../../../components/ui/button'
import { useSellerCommissionFilterController } from './useSellerCommissionFilterController'
import { FilterSelectStyle } from '../../../../../components/BasicFilter/FilterSelectStyle'
import { BasicFilter } from '../../../../../components/BasicFilter'
import { optionsStatusSelect } from '../../../../../../app/utils/status'
import { DateRangePicker } from '@/view/components/DateRangePicker'

export const SellerCommissionFilter = () => {
  const {
    errors,
    handleClearFilter,
    handleFilterSubmit,
    handleSelectStatus,
    selectedStatusOptions,
    isSubmitting,
    handleSelectCommissionType,
    optionCommissionType,
    selectedCommissionTypeOptions,
    selectedDate,
    handleDateChange,
  } = useSellerCommissionFilterController()

  const { DropdownIndicator, customStyles } = FilterSelectStyle({
    isMulti: true,
  })

  return (
    <div className="flex items-center justify-between">
      <BasicFilter>
        <form onSubmit={handleFilterSubmit}>
          <div className="px-4">
            <h2 className="mb-2 font-medium text-black04">Data</h2>
            <DateRangePicker
              date={selectedDate}
              onDateChange={handleDateChange}
              numberOfMonths={1}
            />
          </div>
          <div className="space-y-4 p-4">
            <div className="space-y-2">
              <h3 className="font-medium text-black04">Status</h3>
              <Select
                options={optionsStatusSelect}
                isMulti
                onChange={handleSelectStatus}
                value={selectedStatusOptions}
                placeholder="Selecione o(s) status"
                styles={customStyles}
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator,
                }}
              />
              {errors.status?.message}
            </div>
          </div>
          <div className="space-y-4 p-4">
            <div className="space-y-2">
              <h3 className="font-medium text-black04">Tipo</h3>
              <Select
                options={optionCommissionType}
                isMulti
                onChange={handleSelectCommissionType}
                value={selectedCommissionTypeOptions}
                placeholder="Selecione o(s) tipo(s)"
                styles={customStyles}
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator,
                }}
              />
              {errors.type?.message}
            </div>
          </div>
          <div className="my-5 w-full border-b-[1px] border-gray01" />
          <div className="flex items-center justify-between p-4">
            <Button
              onClick={handleClearFilter}
              variant="outline"
              className="w-24 rounded-full bg-gray02 text-xs font-bold"
            >
              Limpar
            </Button>
            <Button
              type="submit"
              disabled={isSubmitting}
              className="w-20 rounded-full bg-primary text-xs font-bold text-white01"
            >
              Filtrar
            </Button>
          </div>
        </form>
      </BasicFilter>
    </div>
  )
}
